import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Paul Maina </span>
            from <span className="purple"> kenya</span>
            <br />
            I am currently freelance software developer.
            <br />
            Bachelor in Information technology
            Jomo Kenyatta University of Agriculture and Technology
            <br/> final year
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Training kids on web development
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> CTF Challenges
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Code || Secure || Repeat"{" "}
          </p>
          <footer className="blockquote-footer">MAINA</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
